import { createRootRoute } from "@tanstack/react-router";
import { NotFoundComponent } from "shared-ts-router";

export const Route = createRootRoute({
  notFoundComponent: () => <NotFoundComponent />,
});
